export default "__VITE_ASSET__CmFUIEpO__"